const SLASHES_REGEX = /^\/|\/$/g;
export const normalUrl = (url) => url ? url.replace(SLASHES_REGEX, '') : ''
export const joinUrl = (...urls) => urls.map(normalUrl).join('/')